module.exports = __webpack_public_path__ + "static/img/item-6-3-big.b19fe47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-6-3-big.png
// module id = w3Og
// module chunks = 2